import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { StorageService } from 'sigv-library';

@Injectable({
  providedIn: 'root',
})
export class RouterHistoryService {
  exPreviousPath = [] as string[];
  previousPath = [] as string[];
  currentPath = [] as string[];
  trigger ? = '';
  constructor(private router: Router, private storageService: StorageService) {}

  initWatch(): void{
    this.router.events
    .pipe(filter((event) => event instanceof NavigationEnd))
    .subscribe((event) => {
      if (event instanceof NavigationEnd){
        this.trigger = this.router.getCurrentNavigation()?.trigger;
        const segments = this.router.parseUrl(event.url).root.children.primary?.segments.slice(-2);

        if (segments){
          this.exPreviousPath = this.previousPath;
          this.previousPath = this.currentPath;
          this.currentPath = segments.map(({path}) => path);
        }else{
          this.exPreviousPath = [];
          this.previousPath = [];
          this.currentPath = [];
        }

        // 進件會有this.location.back();回前導頁
        // 所以可利用side-menu.component的goToPage function，他會刪除web-submission
        // 因此只要web-submission為null就不會被影響
        const submission = this.storageService.local.getItem('web-submission');
        if (
          this.trigger === 'popstate' &&
          JSON.stringify(this.currentPath) === JSON.stringify(this.exPreviousPath) &&
          submission === null
        ){
          const query = this.storageService.session.getItem('query-detail');
          const page = this.storageService.session.getItem('record-page');
          this.storageService.session.removeItem('query-detail');
          this.storageService.session.removeItem('record-page');
          this.storageService.session.setItem('popstate-query-detail', query);
          this.storageService.session.setItem('popstate-record-page', page);
        }
      }
    });
  }
}
